
import PropTypes from 'prop-types'
import React from 'react'
import css from './index.module.css'
import Space from 'ui/Space'
import FullscreenModal from 'ui/FullscreenModal'
import SetupTopbar from 'ui/SetupTopbar'

const WarehouseSetup = props => (
  <FullscreenModal isShowing={props.isShowing}>
    <div className={css.main}>
      <SetupTopbar
        title='Add Warehouse'
        steps={[
          { label: 'Select Database', isComplete: props.databaseSelected },
          { label: 'Enter Credentials', isComplete: props.databaseConnected }
        ]}
        buttonOnClick={props.cancelSetup}
        buttonText='Cancel' />

      <Space value='60' />
      {props.children}
      <Space value='100' />
    </div>
  </FullscreenModal>
)

WarehouseSetup.displayName = 'WarehouseSetup'

WarehouseSetup.propTypes = {
  cancelSetup: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
  databaseConnected: PropTypes.bool.isRequired,
  databaseSelected: PropTypes.bool.isRequired,
  isShowing: PropTypes.bool.isRequired
}

export default WarehouseSetup



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/components/warehouse-setup/index.js